// Services
import callAPI from "../callApi";
import path from "../variables";

const Compagny = {
	getAll: (filter?: any) =>
		callAPI(
			"GET",
			`${path.base}/administration/enterprises${filter ? filter : ""}`,
			"",
			"getting all Compagnies"
		),
	getAllUsers: (params?: any) =>
		callAPI(
			"GET",
			`${path.base}/administration/users${params ? params : ""}`,
			"",
			"getting all Users Enterprise"
		),
	create: (data: any) =>
		callAPI("POST", `${path.base}/administration/enterprises`, data, "register new Compagny"),
	changeStatus: (params: string) =>
		callAPI("PUT", `${path.base}/administration/enterprises/change-status${params ?? ''}`, '', "update Compagny Status"),
};

export default Compagny;
